import { Button } from '@mui/material';
import { Stack } from '@mui/system';
import React from 'react';

import { GREY, GREY1, GREY2 } from '@/theme/palette';

interface FooterProps {
  onCancel: () => void;
  onSubmit?: () => void;
  mode?: 'create' | 'view' | 'edit';
  submitting?: boolean;
  disabled?: boolean;
}

const Footer: React.FC<FooterProps> = ({
  onCancel,
  onSubmit,
  mode = 'create',
  submitting = false,
  disabled = false,
}) => {
  return (
    <Stack
      direction="row"
      justifyContent={mode === 'view' ? 'flex-end' : 'space-between'}
      alignItems="center"
      sx={{
        px: 3.5,
        py: 2,
        backgroundColor: '#FFFFFF',
        borderTop: `1px solid ${GREY}`,
      }}
    >
      <Button
        variant="outlined"
        onClick={onCancel}
        sx={{
          textTransform: 'none',
          fontWeight: 600,
          fontSize: 13.5,
          px: 4,
          py: 1,
          borderColor: GREY,
          '&:hover': { borderColor: GREY1, backgroundColor: GREY2 },
        }}
      >
        {mode === 'view' ? 'Close' : 'Cancel'}
      </Button>

      {mode !== 'view' && (
        <Button
          variant="contained"
          disableElevation
          onClick={onSubmit}
          disabled={disabled || submitting}
          sx={{ textTransform: 'none', fontWeight: 600, fontSize: 13.5, px: 4, py: 1.1 }}
        >
          {submitting ? 'Saving...' : mode === 'edit' ? 'Save Changes' : 'Create Resource'}
        </Button>
      )}
    </Stack>
  );
};

export default Footer;
